// extracted by mini-css-extract-plugin
export var cardContainer = "ResourceCard-module--card-container--3uU4e";
export var cardShadow = "ResourceCard-module--card-shadow--37dJs";
export var cardContentContainer = "ResourceCard-module--card-content-container--1GHeU";